module.exports = __webpack_public_path__ + "static/media/space.ea40b07d.jpg";